import { lazy } from 'react';

const MenuGlobal = lazy(() => import(/* webpackChunkName: "menuglobal" */ './menu-global.js'));

export default MenuGlobal;
